module.exports = {
    digitalPayPaymentTypes: {
        giftCardType: 'GiftCard',
        paypalType: 'PayPal',
        creditCardType: 'CreditCard',
        onAccountType: 'OnAccount',
        emptyType: 'None',
        unknownType: 'NotSet',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-paymenttypes.js